export default __webpack_public_path__ + "static/media/montage-lmtr_2-variante-5.9e6fbfa8.jpeg";